import React, { useEffect, useState } from "react"
import { Row } from "reactstrap"

// ─── Helpers ──────────────────────────────────────────────────────────────────
const isEmpty = val =>
  val === null ||
  val === undefined ||
  String(val).trim() === "" ||
  String(val).trim().toLowerCase() === "null" ||
  String(val).trim().toLowerCase() === "undefined"

const clean = val => (isEmpty(val) ? "" : val)
const inputCls = val => `form-control ${isEmpty(val) ? "border-danger" : ""}`

// ─── Component ────────────────────────────────────────────────────────────────
const Education = ({ staffData, verticalActiveTab }) => {
  const [inputFields_1, setInputFields1] = useState([{}])

  useEffect(() => {
    if (verticalActiveTab == "4") {
      let educationGroup
      if (staffData?.education_group != undefined) {
        educationGroup = JSON.parse(staffData.education_group)
      }
      if (educationGroup !== null) {
        setInputFields1(educationGroup)
      }
    }
  }, [verticalActiveTab])

  return (
    <>
      <div className="repeater">
        <div className="p-4 pb-0 bg-white shadow">
          <Row>
            <div className="col-md-6">
              <h4 className="text-dark">Education</h4>
            </div>
          </Row>
        </div>

        {(inputFields_1 || []).map((formRow, key) => (
          <div key={key} className="mb-3 p-4 bg-white shadow">
            <div className="row align-items-end">

              <div className="col-md-5 mb-3">
                <label>Board/Institute</label>
                <input
                  type="text"
                  placeholder="Enter Board/Institute"
                  className={inputCls(formRow.board)}
                  name="board"
                  value={clean(formRow.board)}
                  disabled={true}
                />
              </div>

              <div className="col-md-3 mb-3">
                <label>Field</label>
                <input
                  type="text"
                  placeholder="Enter Field"
                  className={inputCls(formRow.field)}
                  name="field"
                  value={clean(formRow.field)}
                  disabled={true}
                />
              </div>

              <div className="col-md-3 mb-3">
                <div className="row">
                  <div className="col-6">
                    <label>Year</label>
                    <input
                      type="text"
                      placeholder="Year"
                      className={inputCls(formRow.year)}
                      name="year"
                      value={clean(formRow.year)}
                      disabled={true}
                    />
                  </div>
                  <div className="col-4">
                    <label>Percentage</label>
                    <input
                      type="text"
                      placeholder="%"
                      className={inputCls(formRow.class)}
                      name="class"
                      value={clean(formRow.class)}
                      disabled={true}
                    />
                  </div>
                </div>
              </div>

            </div>
          </div>
        ))}
      </div>
    </>
  )
}

export default Education